import '.a1{position:fixed;}.ssr-plugin'
import '.co{top:0;}.ssr-plugin'
import '.aq{left:0px;}.ssr-plugin'
import '.ar{right:0px;}.ssr-plugin'
import '.fm{bottom:0px;}.ssr-plugin'
import '.hh{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.hi{z-index:998;}.ssr-plugin'
import '.hj{transition:opacity 0.3s ease;}.ssr-plugin'
import '.a9{height:100vh;}.ssr-plugin'
import '.a6{width:100%;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.hk{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.hl{z-index:999;}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.a7{justify-content:space-between;}.ssr-plugin'
import '.bv{padding:1.5rem;}.ssr-plugin'
import '.hm{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.bq{flex-shrink:0;}.ssr-plugin'
import '.c6{flex:1;}.ssr-plugin'
import '.af{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a1 co aq ar fm hh hi hj"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a1 co a9 a6 ae hk hl g k"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="g l a7 bv hm bq"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="c6 af bv"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
